import React from "react";

import "./feedbackSurvey.scss";
import like from "../../assets/images/like.png";
import dislike from "../../assets/images/dislike.png";

const FeedbackSurvey = () => {
  return (
    <div className="feedback-survey">
      <div className="text">
        Did this answer your concern ?
      </div>
      <div className="pos-button">
        <div className="pos-icon">
          <img src={like} />
        </div>
        <div className="pos-text">Yes</div>
      </div>
      <div className="neg-button">
        <div className="neg-icon">
          <img src={dislike} />
        </div>
        <div className="neg-text">No</div>
      </div>
    </div>
  );
};

export default FeedbackSurvey;
